import { render } from "./PublishDialog.vue?vue&type=template&id=7fbe933d&scoped=true&ts=true"
import script from "./PublishDialog.vue?vue&type=script&lang=ts"
export * from "./PublishDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbe933d"]])

export default __exports__